import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

const initialState = {
  period: {
    start: null,
    end: null,
  },
  guests: 1,
  fee: 0,
  who: { adults: 1 },
};

export const ReservationSlice = createSlice({
  name: "reservation",
  initialState,
  reducers: {
    setReservationPeriod: (state, action) => {
      // 🚀 OPTIMIZED: Only update if values actually changed
      if (state.period.start !== action.payload.start || 
          state.period.end !== action.payload.end) {
        state.period = action.payload;
      }
    },
    setReservationGuests: (state, action) => {
      // 🚀 OPTIMIZED: Only update if value actually changed
      if (state.guests !== action.payload) {
        state.guests = action.payload;
      }
    },
    setReservationFee: (state, action) => {
      const raw = action.payload;
      const num =
        typeof raw === "object" && raw !== null && "fee" in raw
          ? Number(raw.fee)
          : Number(raw);
      const value = Number.isFinite(num) ? num : 0;
      if (state.fee !== value) {
        state.fee = value;
      }
    },
    setWho: (state, action) => {
      // 🚀 OPTIMIZED: Only update if values actually changed
      const newWho = action.payload;
      const currentWho = state.who;
      
      // Check if any values changed
      const changed = Object.keys(newWho).some(
        key => currentWho[key] !== newWho[key]
      ) || Object.keys(currentWho).some(
        key => !(key in newWho)
      );
      
      if (changed) {
        state.who = newWho;
        // Calculate guests count
        let temp = 0;
        let keys = Object.keys(state.who);
        for (let i = 0; i < keys.length; i++) {
          if (keys[i] === "adults" || keys[i] === "children")
            temp += state.who[keys[i]];
        }
        // Only update guests if count changed
        if (state.guests !== temp) {
          state.guests = temp;
        }
      }
    },
    // 🚀 OPTIMIZED: Clear reservation data after successful reservation
    clearReservation: (state) => {
      state.period = { start: null, end: null };
      state.guests = 1;
      // fee is a global platform setting, not per-reservation — do not reset
      state.who = { adults: 1 };
    },
  },
});

export const {
  setReservationGuests,
  setWho,
  setReservationPeriod,
  setReservationFee,
  clearReservation,
} = ReservationSlice.actions;

// 🚀 OPTIMIZED: Memoized selectors to prevent unnecessary re-renders
export const selectReservationPeriod = (state) => state.reservation.period;
export const selectReservationGuests = (state) => state.reservation.guests;
export const selectReservationFee = (state) => state.reservation.fee;
export const selectReservationWho = (state) => state.reservation.who;

// 🚀 OPTIMIZED: Combined selector for components that need all reservation data
export const selectReservationData = createSelector(
  [selectReservationPeriod, selectReservationGuests, selectReservationFee, selectReservationWho],
  (period, guests, fee, who) => ({
    period,
    guests,
    fee,
    who,
  })
);

export default ReservationSlice.reducer;
